export default {
  en: {
    id: 'exercise5',
    answers: [
      {
        title: `
                <div class="box-title">Enter the SEI&M market</div>`,
        answer: 1,
        hasArrow: true
      },
      {
        title: `<div class="box-title">In danger of being broken up</div>`,
        answer: 2,
        hasArrow: true
      },
      {
        title: `<div class="box-title"> Not easy to be successful</div>
                <div>
                 - Highly competitive<br/>
                 - Many niches<br/>
                </div>`,
        answer: 3,
        hasArrow: true
      },
      {
        title: `
                <div class="box-title">Internal demand for services slowing</div>`,
        answer: 4,
        hasArrow: true
      },
      {
        title: `
                <div class="box-title">Avoid being broken up</div>
                <div>
                	- Make use of expertise<br/>
                	- Make money
                </div>`,
        answer: 5,
        hasArrow: true
      },
      {
        title: `
                <div class="box-title">Come up with right strategy based on our strengths</div>`,
        answer: 6,
        hasArrow: true
      },
      {
        title: `<div class="box-title">Be successful in mktpl</div>`,
        answer: 7
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise5.js